import React from 'react'

const TensionerRotationSensorReminder = () => (
  <div
    style={{
      marginTop: '16px',
      marginBottom: '8px',
      padding: '12px 16px',
      backgroundColor: '#e3f2fd',
      border: '1px solid #90caf9',
      borderRadius: '4px',
      color: '#1565c0',
      fontSize: '14px',
      lineHeight: '1.5'
    }}
  >
    <strong>Friendly Reminder:</strong> You have selected{' '}
    <strong>Tensioner</strong> as the Construction Vehicle Type. Tensioners have
    a rotation sensor installed to track rotation. Please make sure the{' '}
    <strong>Rotation Sensor</strong> option is enabled so that rotation tracking
    and downstream logic work correctly.
  </div>
)

export default TensionerRotationSensorReminder



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/TensionerRotationSensorReminder.jsx